export enum StorageFolder {
  plano_atividade = 'plano_atividade',
  relatorio = 'relatorio',
}
